import { motion } from "framer-motion";

const STEPS = [
  {
    n: "01",
    t: "Discovery & Planning",
    d: "We map the business, the users and the constraints. Outputs: written technical brief, architecture sketch, phased scope and a real budget — no vague estimates.",
  },
  {
    n: "02",
    t: "Design & Architecture",
    d: "UX flows, data models and API contracts drafted in parallel. We commit to shape before we write features, so nothing rebuilds twice.",
  },
  {
    n: "03",
    t: "Agile Development",
    d: "Weekly delivery cadence, agentic AI-augmented pairing, code review discipline. You see running software every sprint — not slide decks.",
  },
  {
    n: "04",
    t: "Deployment & Support",
    d: "AWS infrastructure-as-code, CI/CD, monitoring and post-launch SLAs. We do not disappear at go-live.",
  },
];

export default function Process() {
  return (
    <section
      id="process"
      data-testid="process-section"
      className="relative border-t border-hairline py-24 md:py-32"
    >
      <div className="mx-auto max-w-[1440px] px-6 md:px-10">
        <div className="grid md:grid-cols-12 gap-8 mb-16 md:mb-20 items-end">
          <div className="md:col-span-3">
            <span className="mono-label">[06] Method</span>
          </div>
          <div className="md:col-span-9">
            <motion.h2
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-15% 0px" }}
              transition={{ duration: 0.7 }}
              className="font-display text-4xl md:text-6xl lg:text-7xl tracking-[-0.03em] leading-[0.98]"
            >
              Four chapters.
              <br />
              <span className="text-white/40">No mystery, no drama.</span>
            </motion.h2>
          </div>
        </div>

        <div>
          {STEPS.map((s, i) => (
            <motion.div
              key={s.n}
              data-testid={`process-step-${s.n}`}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-8% 0px" }}
              transition={{ duration: 0.7, delay: i * 0.06, ease: [0.2, 0.7, 0.2, 1] }}
              className="grid md:grid-cols-12 gap-6 md:gap-10 border-t border-hairline py-14 md:py-20 last:border-b group"
            >
              <div className="md:col-span-5">
                <div className="font-mono text-[color:var(--accent)] text-[13px] mb-4">CHAPTER {s.n}</div>
                <div className="font-display text-[18vw] md:text-[12vw] lg:text-[220px] leading-[0.85] tracking-[-0.05em] text-white/95 group-hover:text-[color:var(--accent)] transition-colors">
                  {s.n}
                </div>
              </div>
              <div className="md:col-span-7 md:pl-8 border-l border-hairline md:pt-8">
                <h3 className="font-display text-3xl md:text-5xl tracking-tight leading-tight">
                  {s.t}
                </h3>
                <p className="mt-6 text-white/60 text-[16px] md:text-[17px] leading-[1.7] max-w-[52ch]">
                  {s.d}
                </p>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
